import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialGlobalState from './global-initial-state';
import { selectClosedAnnouncementIds } from './global.selectors';

const globalSlice = createSlice({
    name: 'globalSlice',
    initialState: initialGlobalState,
    reducers: {
        setLang(state, { payload }: PayloadAction<string>) {
            state.lang = payload;
        },
        setActiveMenuItemKey(state, { payload }: PayloadAction<number>) {
            state.activeMenuItemKey = payload;
        },
        setActiveMenuGroupKey(state, { payload }: PayloadAction<number | null>) {
            state.activeMenuGroupKey = payload;
        },
        setIsLightTheme(state, { payload }: PayloadAction<boolean>) {
            state.isLightTheme = payload;
        },
        setIsMenuCollapsed(state, { payload }: PayloadAction<boolean>) {
            state.isMenuCollapsed = !payload;
        },
        setIsNotifShow(state, { payload }: PayloadAction<boolean>) {
            state.showNotif = payload;
        },
        setNoActionReportCount(state, { payload }: PayloadAction<number>) {
            state.noActionReportCount = payload;
        },
        setDefaultPageSize(state, { payload }: PayloadAction<number>) {
            state.defualtPageSize = payload;
        },
        setOpenedKeys: (state, action: PayloadAction<string[]>) => {
            state.openedKeys = action.payload;
        },
        setShowMessage: (state, action: PayloadAction<boolean>) => {
            state.showMessage = action.payload;
        },
        setClosedAnnouncementIds: (state, action: PayloadAction<string>) => {
            state.closedAnnouncementIds = [...state.closedAnnouncementIds, action.payload];
        },
    }
});

export const {
    setLang,
    setActiveMenuItemKey,
    setActiveMenuGroupKey,
    setIsLightTheme,
    setIsMenuCollapsed,
    setIsNotifShow,
    setNoActionReportCount,
    setDefaultPageSize,
    setOpenedKeys,
    setShowMessage,
    setClosedAnnouncementIds
} = globalSlice.actions

export default globalSlice.reducer